import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/components/ui/Skeleton.tsx");
